import {
  platformAppName,
  requestManagement,
  mobilityAppName
} from "../data/platform-data";

export enum BvtFeatureFlags {
  TEDIG8380Mpex5gSlicing = "TEDIG8380Mpex5gSlicing",
}

export interface IFeatureFlagWithBVT {
  bvtEnabledFeature: boolean;
  flagState: boolean;
}

export type FlagApplicationNames =
| typeof platformAppName
| typeof requestManagement
| typeof mobilityAppName;

export interface IUseBvtFlagsCheckerProps {
  bvtFlagName: BvtFeatureFlags;
  cidn?: string;
  appName?: FlagApplicationNames;
}
